import { useEffect } from 'react'

export function useDataAndSetLoadedState<P, R>(args: {
  useLoader: (props: P) => { data: R; isLoadingOrIdle: boolean }
  props: P
  setLoadedSignal: (loaded: boolean) => void
}) {
  const { useLoader, props, setLoadedSignal } = args
  const { data, isLoadingOrIdle } = useLoader(props)

  useEffect(() => {
    setLoadedSignal(!isLoadingOrIdle) // invert the loading state to get the loaded state
  }, [isLoadingOrIdle])

  return { data, isLoadingOrIdle }
}
